import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpParamNames } from 'src/app/core/constantes/http_param-names';
import { ReminderNotification } from 'src/app/models/server/reminderNotification';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class ReminderNotificationsService extends ServiceBase {
    constructor(
        private http: HttpClient,
        public override connectedUserStateService: ConnectedUsersStateService
    ) {
        super(connectedUserStateService);
    }

    /**
     * Liste les notifications de rappels d'un dossier.
     * @param viewId  : Id de la vue.
     * @param folderId : Id du dossier
     * @returns Liste des notifications de rappels.
     */
    public GetFolderReminderNotifications(viewId: number, folderId: string): Observable<ReminderNotification[]> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            params: new HttpParams().set(HttpParamNames.ACTIVE, true.toString()),
        };

        return this.http
            .get<ReminderNotification[]>(this.baseUrl + `/api/organizations/${this.organizationId}/views/${viewId}/folders/${folderId}/reminders/notifications`, httpOptions)
            .pipe(
                map((x) => {
                    x.forEach((y) => {
                        y.closeDate = new Date(y.closeDate);
                        y.creationDate = new Date(y.creationDate);
                    });
                    return x;
                })
            );
    }

    /**
     * Met à jour une notification de rappel d'un dossier.
     * @param viewId  : Id de la vue.
     * @param reminderNotification : Instance de la notification du rappel.
     * @returns : L'instance de la notification de rappel modifiée.
     */
    public update(viewId: number, folderId: string, reminderNotification: ReminderNotification): Observable<ReminderNotification> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        return this.http
            .put<ReminderNotification>(
                this.baseUrl +
                    `/api/organizations/${this.organizationId}/views/${viewId}/folders/${folderId}/reminders/${reminderNotification.reminderId}/notifications/${reminderNotification.id}`,
                reminderNotification,
                httpOptions
            )
            .pipe(
                map((x) => {
                    return x;
                })
            );
    }
}
